/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getDrawSystemGameTypeAteVolumeByCustomerId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_BY_CUSTOMER_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/ate-volume/:customerId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeAteVolumeByCustomerId,
  },
  {
    action: 'getDrawSystemGameTypeAteVolumeRecipesByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_RECIPES_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/ate-value-volume-recipes/:compositeKey',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_RECIPE,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeAteVolumeRecipesByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeOverallVolumeByCustomerId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_BY_CUSTOMER_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/overall-volume/:customerId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeOverallVolumeByCustomerId,
  },
  {
    action: 'getDrawSystemGameTypeOverallVolumeRecipesByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_RECIPES_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/overall-volume-recipes/:compositeKey',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_RECIPE,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeOverallVolumeRecipesByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeReportStrikeOverviewByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_REPORT_STRIKE_OVERVIEW_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/report-strike-overview/:compositeKey',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_REPORT_STRIKE_OVERVIEW,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeReportStrikeOverviewByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeReportVolumeByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/report-volume/:compositeKey',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeReportVolumeByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeReportVolumeRecipesByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_RECIPES_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/report-volume-recipes/:compositeKey',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_RECIPE,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeReportVolumeRecipesByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeTankedVolumeByCustomerId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_BY_CUSTOMER_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/tanked-volume/:customerId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeTankedVolumeByCustomerId,
  },
  {
    action: 'getDrawSystemGameTypeTankedVolumeRecipesByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_RECIPES_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/tanked-value-volume-recipes/:compositeKey',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_RECIPE,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypeTankedVolumeRecipesByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypesBySystemGameId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPES_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game-types/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE,
    requestSchema: requestSchemas.drawSystemGameTypes.getDrawSystemGameTypesBySystemGameId,
    scopes: [
      scopes.DEFAULT,
      scopes.DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
    ],
  },
  {
    action: 'resynchronizeDrawSystemGameTypeContract',
    message: messages.SUCCESS_RESYNCHRONIZE_DRAW_SYSTEM_GAME_TYPE_CONTRACT,
    method: 'PATCH',
    path: '/draw/:drawId/system-game-type/:systemGameTypeId/contract/resynchronize',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.RESYNCHRONIZE_DRAW_SYSTEM_GAME_TYPE_CONTRACT,
    requestSchema: requestSchemas.drawSystemGameTypes.resynchronizeDrawSystemGameTypeContract,
  },
];
